import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBkLjUG90Drj9Zjfek5YnMHxV9GOtHMpgg",
  authDomain: "challenge-8ca17.firebaseapp.com",
  databaseURL: "https://challenge-8ca17.firebaseio.com",
  projectId: "challenge-8ca17",
  storageBucket: "challenge-8ca17.appspot.com",
  messagingSenderId: "699533751817",
  appId: "1:699533751817:web:c569c72c832f47dad02ad8",
  measurementId: "G-S81JF5ELKB",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();

export { db, auth };
